import type { FC } from 'react';
import type { CourseWithProgress } from '@teachur/http-client';
import type { CourseStep } from '../../../contexts/SingleCourseProvider';
import { BookOpen, FileText, FolderOpen, Users } from 'lucide-react';

export type StepStatus = 'locked' | 'completed' | 'current';

interface CourseStepConfig {
  key: CourseStep;
  label: string;
  stepIcon: FC<{ className?: string }>;
  getStatus: (course: CourseWithProgress | null) => StepStatus;
}

export const COURSE_STEPS: CourseStepConfig[] = [
  {
    key: 'self',
    label: 'Self-assess',
    stepIcon: BookOpen,
    getStatus: (course) => {
      if (!course) return 'locked';

      if (
        course.quizCompleted ||
        course.status === 'completed' ||
        course.selfAssessmentCompletionPercentage >= 100 ||
        course.coursePassed
      ) {
        return 'completed';
      }

      if (course.status === 'notStarted') return 'locked';

      return 'current';
    },
  },
  {
    key: 'exam',
    label: 'Course Exam',
    stepIcon: FileText,
    getStatus: (course) => {
      if (!course) return 'locked';

      if (course.quizCompleted || course.status === 'completed' || course.coursePassed) {
        return 'completed';
      }

      if ((course.selfAssessmentCompletionPercentage ?? 0) < 100) {
        return 'locked';
      }

      return 'current';
    },
  },
  {
    key: 'project',
    label: 'Course Project',
    stepIcon: FolderOpen,
    getStatus: (course) => {
      if (!course) return 'locked';

      if (course.status === 'completed' || course.coursePassed) {
        return 'completed';
      }
      if (!course.quizCompleted) return 'locked';

      return course.projectCompleted ? 'completed' : 'current';
    },
  },
  {
    key: 'hearing',
    label: 'Course Hearing',
    stepIcon: Users,
    getStatus: (course) => {
      if (!course) return 'locked';

      if (course.status === 'completed' || course.coursePassed) {
        return 'completed';
      }
      if (!course.projectCompleted) return 'locked';

      return course.coursePassed ? 'completed' : 'current';
    },
  },
];
